/** @flow **/
export const key = 'productList'
